
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/katalog-firm/[slug]",
      function () {
        return require("private-next-pages/katalog-firm/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/katalog-firm/[slug]"])
      });
    }
  